import script from "./AgencyHelpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AgencyHelpPage.vue?vue&type=script&setup=true&lang=js"

import "./AgencyHelpPage.vue?vue&type=style&index=0&id=8a77a590&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a77a590"]])

export default __exports__